import { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@quintoandar-tokko/jopijs';
import { setPerformanceModals } from '@/store/slices/components/dashboard/DashboardSlice';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import TableDropdown from '@/components/Dashboard/DashboardTables/components/TableDropdown';
import styles from './performanceModals.module.scss';
import useTrackPerformanceTable from '@/components/Dashboard/customHooks/useTrackDashboard';
import { TRACK_ELEMENT } from '@/components/Dashboard/constants/track';

export default function SearchInput({
  modal,
  dropdownOptions = [],
  maxWidth = '100%',
  ...rest
}) {
  const dispatch = useDispatch();
  const { performanceModals } = useSelector((state) => state.DashboardSlice);
  const [inputValue, setInputValue] = useState('');
  const { searchQuery, searchType } = performanceModals[modal];
  const track = useTrackPerformanceTable();
  const hasTrackedSearchRef = useRef(false);

  useEffect(() => {
    setInputValue(searchQuery);
  }, [searchQuery]);

  let debounceTimer;
  const handleChangeInput = useCallback((event) => {
    const { value } = event.target;
    setInputValue(value);
    const clearQuery = value.trim();

    if (!hasTrackedSearchRef.current && clearQuery.length >= 3) {
      hasTrackedSearchRef.current = true;
      if (track[modal]) track[modal](TRACK_ELEMENT.SEARCH_INPUT);
    }

    if (clearQuery.length === 0 || clearQuery.length >= 3) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        dispatch(
          setPerformanceModals({
            key: modal,
            subkey: 'searchQuery',
            value,
          })
        );
      }, 1000);
    }
  }, []);

  const selectedTypeOption =
    dropdownOptions.find((option) => option.value === searchType) ??
    dropdownOptions[0];

  const handleSelection = (option) => {
    dispatch(
      setPerformanceModals({
        key: modal,
        subkey: 'searchType',
        value: option.value,
      })
    );
    if (track[modal]) track[modal](TRACK_ELEMENT.DROPDOWN_SEARCH_SELECTION);
  };

  return (
    <Box as="label" className={styles.searchInputWrapper} __css={{ maxWidth }}>
      <Box
        as="input"
        className={styles.searchInput}
        placeholder={Trans(translations, 'Search')}
        value={inputValue}
        onChange={handleChangeInput}
        maxWidth="100%"
        {...rest}
      />

      {dropdownOptions && dropdownOptions.length > 0 && (
        <TableDropdown
          selectedOption={selectedTypeOption}
          options={dropdownOptions}
          onSelect={(option) => handleSelection(option)}
        />
      )}
    </Box>
  );
}
